import {
  breakpointSizes,
  getBreakpointDown,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { connect, useSelector } from 'react-redux'
import { Route, Switch } from 'react-router'
import { AuthenticationAgnosticFlatArchitectureRoutes } from 'src/navigation/flatArchitectureRoutes'
import { Rdrct } from 'src/navigation/Lnk'
import { signinUrl } from 'src/navigation/urls'
import { RootState } from 'src/redux/createRootReducer'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'
import { css } from 'styled-components'

const AuthenticationAgnostic: React.FC = () => {
  const calculatedBackgroundLocation = useSelector(
    selectCalculatedBackgroundLocation,
  )

  return (
    <div
      css={css`
        min-height: 100vh;
        width: 100%;
        background-color: ${styleConstants.colors.gray_light};

        ${getBreakpointDown(breakpointSizes.XSM)(css`
          padding: 40px 10px;
        `)}
      `}
    >
      <Switch location={calculatedBackgroundLocation}>
        {AuthenticationAgnosticFlatArchitectureRoutes.map(
          ({ path, Component }) => (
            <Route exact path={path} key={String(path)}>
              <Component />
            </Route>
          ),
        )}
        <Route path={'/'}>
          <Rdrct to={signinUrl()} />
        </Route>
      </Switch>
    </div>
  )
}

// TODO: this is NOT NECESSARY but for some reason useSelector returns a stale value,
// even when checking the values in the equality comparison and ensuring that a === b is false
export default connect(
  (state: RootState) => ({
    bgl: selectCalculatedBackgroundLocation(state),
  }),
  {},
)(AuthenticationAgnostic)
